import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../../contexts/EncoreContext";
import { Experimental__Icon, findClosestGlyphAvailable } from "../../";
export function Experimental__IconX(props) {
  var iconList = [{
    "size": 16,
    "svgContent": "<path d=\"M14.354 2.353l-.708-.707L8 7.293 2.353 1.646l-.707.707L7.293 8l-5.647 5.646.707.708L8 8.707l5.646 5.647.708-.708L8.707 8z\"/>"
  }, {
    "size": 24,
    "svgContent": "<path d=\"M20.354 4.353l-.708-.706L12 11.293 4.353 3.647l-.706.706L11.293 12l-7.646 7.646.706.708L12 12.707l7.646 7.647.708-.708L12.707 12z\"/>"
  }, {
    "size": 32,
    "svgContent": "<path d=\"M26.253 6.454l-.707-.707L16 15.293 6.454 5.747l-.707.707L15.293 16l-9.546 9.546.707.707L16 16.707l9.546 9.546.707-.707L16.707 16z\"/>"
  }, {
    "size": 48,
    "svgContent": "<path d=\"M38.85 10.564L37.436 9.15 24 22.586 10.564 9.15 9.15 10.564 22.586 24 9.15 37.436l1.414 1.414L24 25.414 37.436 38.85l1.414-1.414L25.414 24z\"/>"
  }, {
    "size": 64,
    "svgContent": "<path d=\"M52.506 12.908l-1.414-1.414L32 30.586 12.908 11.494l-1.414 1.414L30.586 32 11.494 51.092l1.414 1.414L32 33.414l19.092 19.092 1.414-1.414L33.414 32z\"/>"
  }];
  var iconListRedraw = [{
    "size": 16,
    "svgContent": "<path d=\"M1.47 1.47a.75.75 0 011.06 0L8 6.94l5.47-5.47a.75.75 0 111.06 1.06L9.06 8l5.47 5.47a.75.75 0 11-1.06 1.06L8 9.06l-5.47 5.47a.75.75 0 01-1.06-1.06L6.94 8 1.47 2.53a.75.75 0 010-1.06z\"/>"
  }, {
    "size": 24,
    "svgContent": "<path d=\"M3.293 3.293a1 1 0 011.414 0L12 10.586l7.293-7.293a1 1 0 111.414 1.414L13.414 12l7.293 7.293a1 1 0 01-1.414 1.414L12 13.414l-7.293 7.293a1 1 0 01-1.414-1.414L10.586 12 3.293 4.707a1 1 0 010-1.414z\"/>"
  }];
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);
  var iconListFallback = iconList.length === 0 ? iconListRedraw : iconList;
  var closestSize = findClosestGlyphAvailable(status === encoreContextStatus.next ? iconListRedraw : iconListFallback, props.iconSize || 24);
  return /*#__PURE__*/React.createElement(Experimental__Icon, Object.assign({}, props, {
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: closestSize.svgContent
    }
  }));
}
export default Experimental__IconX;